import { useLocation, useParams } from "react-router-dom";
import { useEnrollment } from "@/hooks/useEnrollment";

/**
 * Participants and trainers share the dashboard URL, so the trainer dashboard
 * is recognised by the enrollment owner's role. Only fetches on the dashboard.
 */
export const useIsTrainerDashboard = () => {
  const { pathname } = useLocation();
  const { enrollmentId } = useParams<{ enrollmentId?: string }>();
  const isDashboard = pathname.endsWith("/dashboard");
  const { data: enrollment } = useEnrollment(
    isDashboard ? enrollmentId : undefined
  );
  return isDashboard && enrollment?.user?.role === "trainer";
};
